
export enum PaymentTypeCd {
	CASH = 'Cash',
	COD = 'COD'}

